export const html5String = '[a-zA-Z0-9_]{1,15}';
export const object = /^[a-zA-Z0-9_]{1,15}$/;

export default object;
